<template>
    <div>
        <div v-if="question" :key="question.id" class="slidesSize">
                <b-row>
                    <b-col cols="12" :md="fullWidthCard ? 12 : 10" :lg="fullWidthCard ? 12 : 8" class="mx-auto centered">
                        <b-card class="neu-card neu-card-sv">
                            <slot name="title"></slot>
                            <h2>{{question.question}}</h2>
                            <div>
                                <slot name="question"></slot>
                                <div v-if="!$slots.question">
                                    <b-row>
                                        <b-col :class="[stacked ? 'd-flex justify-content-center' : '']">
                                            <radio-button :labelsEnabled="labelsEnabled" v-model="localValue" :options="question.answer" :class="[stacked ? 'text-left mx-auto centered' : 'mx-auto centered']" style="box-sizing: border-box;" :stacked="stacked"></radio-button>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="!stacked && !labelsEnabled">
                                        <b-col cols="6" sm="6" lg="3" class="subtitle-card"><span>{{ leastImportantAnswer }}</span></b-col>
                                        <b-col cols="6" sm="6" lg="3" class="float-right subtitle-card ml-auto"><span>{{ mostImportantAnswer }}</span></b-col>
                                    </b-row>
                                </div>
                                <slot name="additionalComment"></slot>
                                <b-row>
                                    <b-col v-if="showButton" xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-3 float-right m-auto">
                                        <transition name="fade" appear>
                                            <button type="button" class="btn btn-primary w-100" @click.once="action">
                                                <span class="text-center" >{{ questionText }}</span>
                                                <span class="float-right m-auto"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/></span>
                                            </button>
                                        </transition>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </div>
</template>

<script>
import BaseRadioGroup from '@/components/base/forms/BaseRadioGroup.vue'
import { BCard } from 'bootstrap-vue'
import i18nMixin from '@/mixins/i18n.mixin'

export default {
    mixins: [i18nMixin('public/views/survey')],
    components: {
        'radio-button': BaseRadioGroup,
        BCard
    },
    data () {
        return {
            localValue: null
        }
    },
    props: {
        progress: {
            type: Number,
            required: true
        },
        questionnaireLength: {
            type: Number,
            required: true
        },
        question: {
            type: Object
        },
        value: {
            type: Number,
            default: null
        },
        stacked: {
            type: Boolean,
            default: false
        },
        labelsEnabled: {
            type: Boolean,
            default: false
        },
        fullWidthCard: {
            type: Boolean,
            default: false
        },
        customConditionToShowButton: {
            type: Boolean,
            default: false
        },
        customButtonText: {
            type: String
        }
    },
    created () {
        this.localValue = this.value
        this.$watch('localValue', value => {
            this.$emit('input', value)
        })
        this.$watch('value', newValue => {
            this.localValue = newValue
        })
    },
    methods: {
			action () {
				this.$emit('answerQuestion')
				if (this.lastQuestion) {
						this.$emit('submitQuestionnaire')
				}
			}
    },
    computed: {
        leastImportantAnswer () {
            return this.question.answer[0].text
        },
        mostImportantAnswer () {
            return this.question.answer[this.question.answer.length - 1].text
        },
        questionText () {
            return this.customButtonText || this.question.resultText || this.$t(this.lastQuestion ? 'surveys.finish' : 'surveys.following')
        },
        lastQuestion () {
            return this.progress === this.questionnaireLength - 1
        },
        showButton () {
            return this.customConditionToShowButton || this.localValue != null
        }
    }
}
</script>
<style lang="scss">
    div.custom-radio.b-custom-control-lg:has(span:empty){
        margin-right: 3%;
        margin-left: 3%;
        @include mobile {
            margin: 0.5%;
        }
    }
    .slidesSize {
        width: 100%;
        position: relative;
        z-index: 1;
    }
    .subtitle-card {
        color: $blue;
        font-weight: bold;
        font-size: 1.25rem;
        white-space: normal;
        @include mobile {
            font-size: 1rem;
            display: inline-block;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/utils/QuestionCard.vue